import DataGrid, {
	Column,
	Editing,
	LoadPanel,
} from 'devextreme-react/data-grid';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../../contexts/auth';
import { CompanyTypes } from '../../../../types/enums';
import { OutOfStockOrder } from '../types/OutOfStockOrder';

export default function OutOfStockOrdersGrid(props: { records: OutOfStockOrder[] }) {
	const { user } = useAuth();
	const urlFolder = user?.companyTypeId === CompanyTypes.MFR ? "manufacturer" :
		user?.companyTypeId === CompanyTypes.SERVICE_PROVIDER ? "service-provider" : "distributor";

	return (
		<DataGrid
			className={'dx-card wide-card'}
			dataSource={props.records}
			allowColumnReordering={true}
			allowColumnResizing={true}
			showBorders={true}
			showColumnLines={true}
			columnAutoWidth={false}
			keyExpr={'purchaseOrderID'}
		>
			<LoadPanel enabled={false} />
			<Editing allowUpdating={true} mode={'cell'} refreshMode={'repaint'}></Editing>

			<Column
				dataField={'outOfStockID'}
				caption={'outOfStockID'}
				dataType="number"
				visible={false}
			/>
			<Column
				dataField={'purchaseOrder'}
				caption={'Purchase Order'}
				dataType="string"
				allowEditing={false}
				cellRender={(row: any) => {
					return <Link to={`/${urlFolder}/purchase-order/${row.data.purchaseOrderID}`} target="_blank">
						{row.data.poNumber}
					</Link>;
				}}
			/>
			<Column
				dataField={'orderStatus'}
				caption={'Status'}
				dataType="string"
				allowEditing={false}
			/>
			<Column
				dataField={'cfiName'}
				caption={'CFI'}
				dataType="string"
				allowEditing={false}
			/>
			<Column
				dataField={'locationAddress'}
				caption={'Ship To'}
				dataType="string"
				width={500}
				allowEditing={false}
			/>
			<Column
				dataField={'requestedDeliveryDate'}
				caption={'Requested Delivery Date'}
				dataType="date"
				allowEditing={false}
			/>
			<Column
				dataField={'validatedDeliveryDate'}
				caption={'Validated Delivery Date'}
				dataType="date"
				allowEditing={false}
			/>
			<Column
				dataField={'estimatedDeliveryDate'}
				caption={'Estimated Delivery Date'}
				dataType="date"
				editorOptions={{
					showClearButton: false
				}}
				showEditorAlways={true}
				visible={user?.companyTypeId === CompanyTypes.DISTRIBUTOR}
			/>
		</DataGrid>
	)
} 
